/* eslint-disable no-param-reassign */ /* eslint-disable @typescript-eslint/no-explicit-any */ import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
function isObject(item) {
    return item !== null && typeof item === "object";
}
export function merge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        sources[_key - 1] = arguments[_key];
    }
    if (!sources.length) return target;
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
        // eslint-disable-next-line no-restricted-syntax
        for(var key in source){
            if (isObject(source[key])) {
                if (!isObject(target[key])) {
                    target[key] = {}; // 直接赋值，这比 Object.assign 更直接
                }
                // if (!target[key]) Object.assign(target, { [key]: {} });
                merge(target[key], source[key]);
            } else {
                target[key] = source[key];
            // Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return merge.apply(void 0, [
        target
    ].concat(_to_consumable_array(sources)));
}
export function mapValues(obj, iteratee) {
    var result = {};
    // eslint-disable-next-line no-restricted-syntax
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = iteratee(obj[key], key);
        }
    }
    return result;
}
export function mapKeys(obj, iteratee) {
    return Object.keys(obj).reduce(function(result, key) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        var newKey = iteratee(obj[key], key); // 使用 iteratee 函数来获取新的键
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        result[newKey] = obj[key]; // 将值赋给新的键
        return result;
    }, {});
}
export function forEach(collection, iteratee) {
    if (Array.isArray(collection)) {
        for(var index = 0; index < collection.length; index++){
            if (iteratee(collection[index], index.toString()) === false) {
                break;
            }
        }
    } else {
        var keys = Object.keys(collection);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (iteratee(collection[key], key) === false) {
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
export function isEmpty(value) {
    if (value == null) {
        return true;
    }
    if (typeof value === "string" || Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === "object") {
        return Object.keys(value).length === 0;
    }
    if (_instanceof(value, Map) || _instanceof(value, Set)) {
        return value.size === 0;
    }
    return false;
}
